import { damagedMessageFrom } from '@papan/types'

/**
 * What a failed version restore says — the ONE answer for the version panels (a file's, its preview's, a PDApp's).
 * A refusal the server words for the person speaks in its own words: the db being replaced or a save still landing
 * (#1090 / #1134 `ENGINE_DB_REPLACING`), a stored copy that is damaged (#1397, `damagedMessageFrom` — nothing was
 * restored). Anything else is `fallback` (a raw error is not for the person).
 */
export function restoreErrorText(err: unknown, fallback: string): string {
  const damaged = damagedMessageFrom(err)
  if (damaged) return damaged
  const e = err as { code?: string; message?: string } | null
  return e?.code === 'ENGINE_DB_REPLACING' && e.message ? e.message : fallback
}
